(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[976],{

/***/ 82714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choose-plan",
      function () {
        return __webpack_require__(26577);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useFetch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83244);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44743);
/* harmony import */ var _apiHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65639);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54087);
/* harmony import */ var enums_errors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10367);







function fetcher(url, locale) {
    return _fetcher.apply(this, arguments);
}
function _fetcher() {
    _fetcher = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, locale) {
        var queryParams, ref, ref1, idToken, headers, _args = arguments;
        return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryParams = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {};
                    ;
                    _ctx.next = 4;
                    return (ref = _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === null || _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === void 0 ? void 0 : _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp.auth */ .H.auth()) === null || ref === void 0 ? void 0 : (ref1 = ref.currentUser) === null || ref1 === void 0 ? void 0 : ref1.getIdToken();
                case 4:
                    idToken = _ctx.sent;
                    headers = {
                        "Content-Type": "application/json",
                        "Accept-Language": locale
                    };
                    if (idToken) {
                        headers["Authorization"] = "Bearer ".concat(idToken);
                    }
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .queryStringFromObject */ .jR)(queryParams)), {
                            method: "GET",
                            headers: headers
                        }).then(function(res) {
                            if (res.status === 204) {
                                resolve({});
                            } else if (res.status > 204) {
                                switch(res.status){
                                    case 402:
                                        reject(enums_errors__WEBPACK_IMPORTED_MODULE_5__/* .AppApiError.PaymentNeeded */ .u.PaymentNeeded);
                                        break;
                                    default:
                                        res.json().then(reject);
                                }
                            } else {
                                resolve(res.json());
                            }
                        }).catch(reject);
                    }));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetcher.apply(this, arguments);
}
// hooks use on client side
function useFetch(path, locale) {
    var canLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, queryParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (!path) {
        throw new Error("Path is required");
    }
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(canLoad ? path : null, function() {
        return fetcher(path, locale, queryParams);
    }, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false,
        refreshWhenHidden: false,
        refreshInterval: 0
    }), data = ref.data, error = ref.error, isValidating = ref.isValidating, mutate = ref.mutate;
    return {
        data: data,
        error: error,
        isValidating: isValidating,
        mutate: mutate
    };
}


/***/ }),

/***/ 21779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85429);
/* harmony import */ var _context_stripeContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16096);





var CardInput = function(param) {
    var className = param.className, _disable = param.disable, disable = _disable === void 0 ? false : _disable;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    var ref = (0,_context_stripeContext__WEBPACK_IMPORTED_MODULE_4__/* .useStripeCtx */ .o)(), stripeCard = ref.stripeCard, stripeError = ref.stripeError, setElementsLoaded = ref.setElementsLoaded, enableCardInput = ref.enableCardInput, disableCardInput = ref.disableCardInput;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setElementsLoaded(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        disable && disableCardInput();
        !disable && enableCardInput();
    }, [
        disable
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "stripe-card-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                className: "info-ico card-info-ico",
                "data-tip": true,
                "data-for": "cardInput",
                onClick: function(e) {
                    return e.stopPropagation();
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: className !== null && className !== void 0 ? className : "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "info-label",
                        children: t("common:form.payment_card")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        id: "cardInput",
                        place: "top",
                        effect: "solid",
                        className: "dramox-tooltip",
                        isCapture: true,
                        children: t("common:form.card_tooltip")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: stripeCard,
                        className: "stripe-card"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        ref: stripeError
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardInput);


/***/ }),

/***/ 17194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var _api_useFetch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45509);
/* harmony import */ var _context_authContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13102);
/* harmony import */ var _enums_buyType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10129);
/* harmony import */ var _CardInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21779);
/* harmony import */ var _LoadingComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63104);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53173);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12701);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);











var Cards = function(param) {
    var setSelected = param.setSelected, selected = param.selected, showCountrySelect = param.showCountrySelect;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    var ref = (0,_context_authContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(), user = ref.user, isUserLoaded = ref.isUserLoaded, isAnonymous = ref.isAnonymous, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), countryOptions = ref1[0], setCountryOptions = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), preselectedCountry = ref2[0], setPreselectedCountry = ref2[1];
    var ref3 = (0,_api_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useFetch */ .i)("/user/cards", locale, !!user), cards = ref3.data, isValidating = ref3.isValidating;
    var ref4 = (0,_api_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useFetch */ .i)("countries", locale, isUserLoaded && showCountrySelect), countries = ref4.data;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((cards === null || cards === void 0 ? void 0 : cards.length) > 0) {
            var ref;
            var defaulCard = (ref = cards.find(function(card) {
                return card.is_default;
            })) !== null && ref !== void 0 ? ref : cards[0];
            setSelected(defaulCard.id);
        }
    }, [
        cards
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (countries) {
            var ref;
            setCountryOptions(countries === null || countries === void 0 ? void 0 : countries.map(function(c) {
                return {
                    value: c.id,
                    label: c.title
                };
            }));
            setPreselectedCountry((ref = countries.find(function(c) {
                return c.suggested;
            })) === null || ref === void 0 ? void 0 : ref.id);
        }
    }, [
        countries
    ]);
    var loading = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
    if (!isUserLoaded || isValidating) {
        return loading;
    }
    if (isAnonymous && isUserLoaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: [
                        "email",
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel)
                    ].join(" "),
                    children: [
                        t("common:card_email"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "text",
                            id: "email",
                            name: "email"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                showCountrySelect && !!countryOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: [
                        "email",
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel)
                    ].join(" "),
                    children: [
                        t("common:country"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            options: countryOptions,
                            defaultLabel: t("common:pick_country"),
                            name: "taxCountry",
                            defaultValue: preselectedCountry
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            ]
        });
    }
    var getLabeledCards = function() {
        return cards.map(function(card) {
            return {
                label: "".concat(card.brand[0].toUpperCase() + card.brand.slice(1), " **** ").concat(card.last_four_digits),
                value: card.id
            };
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: cards && cards.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel),
                    children: [
                        t("common:saved_cards"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            defaultLabel: t("common:saved_cards_placeholder"),
                            name: "card",
                            defaultValue: cards[0].id,
                            onChange: setSelected,
                            options: getLabeledCards().concat({
                                label: t("common:add_new_card"),
                                value: _enums_buyType__WEBPACK_IMPORTED_MODULE_5__/* .CardType.NewCard */ .e.NewCard
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                selected === _enums_buyType__WEBPACK_IMPORTED_MODULE_5__/* .CardType.NewCard */ .e.NewCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : null
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Cards);


/***/ }),

/***/ 17383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);


var StripeDisclaimer = function(param) {
    var className = param.className;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        className: "stripe-disclaimer ".concat(className !== null && className !== void 0 ? className : ""),
        children: [
            t("common:form.payment_secured_with"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "external",
                href: "https://stripe.com/",
                title: "stripe",
                children: "stripe"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StripeDisclaimer);


/***/ }),

/***/ 26577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ choose_plan; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./components/Cards/index.tsx
var Cards = __webpack_require__(17194);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./context/authContext.tsx + 3 modules
var authContext = __webpack_require__(13102);
// EXTERNAL MODULE: ./context/stripeContext.tsx + 1 modules
var stripeContext = __webpack_require__(16096);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./pages/choose-plan/index.module.scss
var index_module = __webpack_require__(21861);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./api/apiHelpers.ts
var apiHelpers = __webpack_require__(65639);
// EXTERNAL MODULE: ./helpers/Analytics.ts
var Analytics = __webpack_require__(86639);
// EXTERNAL MODULE: ./components/index.ts + 4 modules
var components = __webpack_require__(66893);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(46834);
// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
;// CONCATENATED MODULE: ./typings/api/user-promo.ts
var CodeType;
(function(CodeType) {
    CodeType["DISCOUNT"] = "DISCOUNT";
    CodeType["PROMO"] = "PROMO";
    CodeType["VOUCHER"] = "VOUCHER";
})(CodeType || (CodeType = {}));
var DurationUnit;
(function(DurationUnit) {
    DurationUnit["MINUTE"] = "MINUTE";
    DurationUnit["HOUR"] = "HOUR";
    DurationUnit["DAY"] = "DAY";
    DurationUnit["WEEK"] = "WEEK";
    DurationUnit["MONTH"] = "MONTH";
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));

;// CONCATENATED MODULE: ./helpers/plans.ts
function rewritePricesForDiscountedPlans(plans) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "purchasable";
    return plans.filter(function(p) {
        return p.is_public && p.price && (type === "purchasable" ? p.is_purchasable : p.is_voucher_compatible);
    }).map(function(plan) {
        if (plan === null || plan === void 0 ? void 0 : plan.discount) {
            plan.price.formatted = plan.discount.price.formatted;
        }
        return plan;
    });
}

// EXTERNAL MODULE: ./components/StripeDisclaimer/index.tsx
var StripeDisclaimer = __webpack_require__(17383);
// EXTERNAL MODULE: ./helpers/storageHelper.ts
var storageHelper = __webpack_require__(38869);
;// CONCATENATED MODULE: ./pages/choose-plan/index.tsx



// @ts-ignore
























var debounceTimer = null;
var ChoosePlan = function(param) {
    var plans = param.plans, priceYearlyDiscount = param.priceYearlyDiscount, type = param.type, countryCode = param.countryCode, host = param.host;
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.ChoosePlan */.lS.ChoosePlan).t;
    var createNotification = (0,context/* useNotificationContext */.nw)().createNotification;
    var formRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var locale = (0,langContext/* useLang */.J)().locale;
    var localisedError = (0,langContext/* useLocalisedError */.k)().localisedError;
    var ref = (0,authContext/* useAuth */.aC)(), user = ref.user, reloadUser = ref.reloadUser;
    var serverError = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(plans), localPlans = ref1[0], setLocalPlans = ref1[1];
    var ref2 = (0,react.useMemo)(function() {
        var country = (0,helpers/* countryFromHost */._P)(host);
        return [
            (0,helpers/* countryHasTrial */.b_)(country),
            country
        ];
    }, [
        host
    ]), isTrialAvailable = ref2[0], userRelatedCountryCode = ref2[1];
    console.log(localPlans);
    var ref3, ref4;
    var ref5 = (0,react.useState)((ref4 = (ref3 = storageHelper/* default.get */.Z.get(enums/* StorageKeys.HOMEPAGE_PLAN_TYPE */.BU.HOMEPAGE_PLAN_TYPE)) !== null && ref3 !== void 0 ? ref3 : type) !== null && ref4 !== void 0 ? ref4 : enums/* QueryType.Monthly */.xL.Monthly), queryType = ref5[0], setQueryType = ref5[1];
    var ref6 = (0,react.useState)(type === enums/* QueryType.Voucher */.xL.Voucher ? enums/* BuyType.Voucher */.D.Voucher : enums/* BuyType.Card */.D.Card), buyType = ref6[0], setBuyType = ref6[1];
    var ref7 = (0,react.useState)(""), selectedCard = ref7[0], setSelectedCard = ref7[1];
    var ref8 = (0,react.useState)(false), redirecting = ref8[0], setRedirecting = ref8[1];
    var ref9 = (0,react.useState)(false), isPromoOpen = ref9[0], openPromo = ref9[1];
    var ref10 = (0,react.useState)(false), submitDisabled = ref10[0], setSubmitDisabled = ref10[1];
    var ref11 = (0,react.useState)({
        value: ""
    }), promoCode = ref11[0], setPromoCode = ref11[1];
    var ref12 = (0,react.useState)(null), promoCodeError = ref12[0], setPromoCodeError = ref12[1];
    var promoCodeRef = (0,react.useRef)(null);
    var ref13 = (0,stripeContext/* useStripeCtx */.o)(), cardHasError = ref13.cardHasError, confirmCardSetup = ref13.confirmCardSetup, stripeError = ref13.stripeError, stripeCard = ref13.stripeCard, confirmCardPayment = ref13.confirmCardPayment, createPaymentMethod = ref13.createPaymentMethod;
    var resetPromoCode = (0,react.useCallback)(function() {
        var promoCodeInput = promoCodeRef.current;
        promoCodeInput.value = "";
        setPromoCode({
            value: ""
        });
        setLocalPlans(plans);
        setSubmitDisabled(false);
        setPromoCodeError(null);
    }, [
        helpers/* removeErrorClass */.G0,
        setPromoCode,
        setLocalPlans,
        setSubmitDisabled,
        promoCodeRef.current,
        plans
    ]);
    var onPromoCodeBlur = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(promoCodeValue) {
            var paymentCodes, updatedPlans;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(promoCodeValue.length > 0)) {
                            _ctx.next = 23;
                            break;
                        }
                        setSubmitDisabled(true);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,client/* getSharedApiClient */.L)().getPaymentCodes(promoCodeValue);
                    case 5:
                        paymentCodes = _ctx.sent;
                        setPromoCode({
                            value: promoCodeValue,
                            type: paymentCodes.type
                        });
                        if (!([
                            CodeType.DISCOUNT,
                            CodeType.PROMO
                        ].indexOf(paymentCodes.type) > -1)) {
                            _ctx.next = 11;
                            break;
                        }
                        {
                            updatedPlans = rewritePricesForDiscountedPlans(paymentCodes.plans);
                            setLocalPlans(updatedPlans);
                        }
                        _ctx.next = 12;
                        break;
                    case 11:
                        throw enums/* AppApiError.CodeDoesNotExist */.ub.CodeDoesNotExist;
                    case 12:
                        (0,helpers/* removeErrorClass */.G0)(formRef.current);
                        setSubmitDisabled(false);
                        setPromoCodeError(null);
                        _ctx.next = 21;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log("e ", _ctx.t0);
                        setPromoCodeError(localisedError(_ctx.t0));
                    case 21:
                        _ctx.next = 24;
                        break;
                    case 23:
                        {
                            resetPromoCode();
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    17
                ]
            ]);
        }));
        return function(promoCodeValue) {
            return _ref.apply(this, arguments);
        };
    }(), [
        client/* getSharedApiClient */.L,
        resetPromoCode,
        setPromoCode,
        promoCode,
        setLocalPlans,
        formRef,
        helpers/* removeErrorClass */.G0,
        setSubmitDisabled, 
    ]);
    (0,react.useEffect)(function() {
        if (promoCodeRef.current) {
            promoCodeRef.current.addEventListener("input", (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var promoCodeStr;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setSubmitDisabled(true);
                            window.clearTimeout(debounceTimer);
                            promoCodeStr = promoCodeRef.current.value;
                            if (promoCodeStr.length >= 0) {
                                // resolve after 200ms (or clear within next key stroke)
                                debounceTimer = window.setTimeout((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.prev = 0;
                                                _ctx.next = 3;
                                                return onPromoCodeBlur(promoCodeStr);
                                            case 3:
                                                _ctx.next = 7;
                                                break;
                                            case 5:
                                                _ctx.prev = 5;
                                                _ctx.t0 = _ctx["catch"](0);
                                            case 7:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            0,
                                            5
                                        ]
                                    ]);
                                })), 500);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })));
        }
    }, [
        promoCodeRef.current,
        onPromoCodeBlur
    ]);
    var redirectHome = (0,react.useMemo)(function() {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(queryString) {
                var userHadSubscription;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setRedirecting(true);
                            userHadSubscription = user.had_subscription;
                            _ctx.next = 4;
                            return (0,apiHelpers/* sleep */._v)(1000);
                        case 4:
                            _ctx.next = 6;
                            return reloadUser();
                        case 6:
                            if (userHadSubscription) {
                                router.push(helpers/* Permalink.root */.xm.root(user, locale, queryString));
                            } else {
                                router.push(helpers/* Permalink.registerContentSettings */.xm.registerContentSettings(locale, queryString));
                            }
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(queryString) {
                return _ref.apply(this, arguments);
            };
        }();
    }, [
        user
    ]);
    var getVoucherInputCls = (0,react.useMemo)(function() {
        if (buyType === enums/* BuyType.Voucher */.D.Voucher) {
            return [
                (index_module_default()).notVisible,
                (index_module_default()).visible
            ].join(" ");
        } else {
            return (index_module_default()).notVisible;
        }
    }, [
        buyType
    ]);
    var getBtnText = (0,react.useMemo)(function() {
        if (queryType === enums/* QueryType.Voucher */.xL.Voucher) {
            return t("redeem_voucher");
        } else if (queryType === enums/* QueryType.Monthly */.xL.Monthly) {
            return t("activate_monthly");
        } else {
            return t("activate_yearly");
        }
    }, [
        queryType
    ]);
    var EMPTY_RULE = t("common:form.not_empty");
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var form, plan, valid, voucher, formSchema, validateObject, voucherInput, planCurrency, payMethod, stripeCardError, respPay, planId, subPlan, logEventToAnalytics, payload, res, checkout, paymentResp;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        form = event.target;
                        plan = form.plan.value;
                        valid = false;
                        if (!(plan === "planVoucher")) {
                            _ctx.next = 31;
                            break;
                        }
                        voucher = form.voucher.value;
                        formSchema = (0,helpers/* createFormSchema */.ZS)({
                            voucher: (0,helpers/* notEmptyRule */.ji)(EMPTY_RULE)
                        });
                        validateObject = {
                            voucher: voucher
                        };
                        valid = (0,helpers/* validateForm */.G$)(formSchema, validateObject, formRef.current);
                        if (!valid) {
                            _ctx.next = 28;
                            break;
                        }
                        _ctx.prev = 11;
                        _ctx.next = 14;
                        return (0,client/* getSharedApiClient */.L)().redeeemVoucher(voucher);
                    case 14:
                        createNotification({
                            title: t("subscription_activated")
                        });
                        Analytics/* default.v2_subscriptionPurchaseWithCoupon */.ZP.v2_subscriptionPurchaseWithCoupon(voucher);
                        _ctx.next = 18;
                        return redirectHome();
                    case 18:
                        _ctx.next = 26;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](11);
                        voucherInput = formRef.current.elements["voucher"];
                        voucherInput.classList.add("error");
                        serverError.current.innerHTML = localisedError(_ctx.t0);
                        (0,helpers/* resetForm */.Fx)(formRef.current);
                    case 26:
                        _ctx.next = 29;
                        break;
                    case 28:
                        {
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        }
                    case 29:
                        _ctx.next = 98;
                        break;
                    case 31:
                        if (!promoCodeError) {
                            _ctx.next = 33;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 33:
                        (0,helpers/* setLoadingState */.bG)(formRef.current);
                        planCurrency = plan.split(":");
                        ;
                        stripeCardError = false;
                        if (!(selectedCard !== enums/* CardType.NewCard */.eT.NewCard && selectedCard !== "")) {
                            _ctx.next = 41;
                            break;
                        }
                        {
                            // user choose saved card, try pay with it
                            payMethod = selectedCard;
                        }
                        _ctx.next = 49;
                        break;
                    case 41:
                        if (cardHasError) {
                            _ctx.next = 48;
                            break;
                        }
                        _ctx.next = 44;
                        return createPaymentMethod();
                    case 44:
                        respPay = _ctx.sent;
                        if (respPay.error) {
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = respPay.error.message;
                            stripeCardError = true;
                        } else {
                            payMethod = respPay.paymentMethod.id;
                        }
                        _ctx.next = 49;
                        break;
                    case 48:
                        {
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = t("card_number_invalid");
                            stripeCardError = true;
                        }
                    case 49:
                        if (stripeCardError) {
                            _ctx.next = 98;
                            break;
                        }
                        planId = parseInt(planCurrency[0]);
                        subPlan = localPlans.find(function(p) {
                            return p.id === planId;
                        });
                        logEventToAnalytics = function() {
                            if (user.had_subscription) {
                                Analytics/* default.v2_subscriptionRenewal */.ZP.v2_subscriptionRenewal(subPlan);
                            } else {
                                Analytics/* default.v2_subscriptionPurchase */.ZP.v2_subscriptionPurchase(subPlan);
                                if (isTrialAvailable && Boolean(subPlan.trial)) {
                                    Analytics/* default.v2_trialStart */.ZP.v2_trialStart();
                                }
                            }
                        };
                        _ctx.prev = 53;
                        payload = {
                            payment_method: payMethod !== null && payMethod !== void 0 ? payMethod : "",
                            currency: subPlan.price.currency,
                            plan_id: planId
                        };
                        if (promoCode.value !== "") {
                            if (promoCode.type === CodeType.DISCOUNT) {
                                payload["discount_code"] = promoCode.value;
                            } else if (promoCode.type === CodeType.PROMO) {
                                payload["promo_code"] = promoCode.value;
                            }
                        }
                        _ctx.next = 58;
                        return (0,client/* getSharedApiClient */.L)().buySubscription(payload);
                    case 58:
                        res = _ctx.sent;
                        if (!(res.status === "CARD_SETUP")) {
                            _ctx.next = 74;
                            break;
                        }
                        _ctx.next = 62;
                        return confirmCardSetup(res.client_secret, user.full_name);
                    case 62:
                        checkout = _ctx.sent;
                        if (!checkout.error) {
                            _ctx.next = 67;
                            break;
                        }
                        {
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = checkout.error.message;
                        }
                        _ctx.next = 72;
                        break;
                    case 67:
                        if (!(checkout.setupIntent.status === "succeeded")) {
                            _ctx.next = 72;
                            break;
                        }
                        createNotification({
                            title: t("subscription_activated")
                        });
                        logEventToAnalytics();
                        _ctx.next = 72;
                        return redirectHome("seznam_cId=".concat(Analytics/* SEZNAM_CID_SUCCESS_SUBSCRIPTION */.Zf));
                    case 72:
                        _ctx.next = 92;
                        break;
                    case 74:
                        if (!(res.status === "ACTION_REQUIRED")) {
                            _ctx.next = 88;
                            break;
                        }
                        _ctx.next = 77;
                        return confirmCardPayment(res.payment_intent_client_secret, null, payload.payment_method);
                    case 77:
                        paymentResp = _ctx.sent;
                        if (!paymentResp.error) {
                            _ctx.next = 82;
                            break;
                        }
                        {
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = paymentResp.error.message;
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        }
                        _ctx.next = 86;
                        break;
                    case 82:
                        createNotification({
                            title: t("subscription_activated")
                        });
                        logEventToAnalytics();
                        _ctx.next = 86;
                        return redirectHome("seznam_cId=".concat(Analytics/* SEZNAM_CID_SUCCESS_SUBSCRIPTION */.Zf));
                    case 86:
                        _ctx.next = 92;
                        break;
                    case 88:
                        createNotification({
                            title: t("subscription_activated")
                        });
                        logEventToAnalytics();
                        _ctx.next = 92;
                        return redirectHome("seznam_cId=".concat(Analytics/* SEZNAM_CID_SUCCESS_SUBSCRIPTION */.Zf));
                    case 92:
                        _ctx.next = 98;
                        break;
                    case 94:
                        _ctx.prev = 94;
                        _ctx.t1 = _ctx["catch"](53);
                        createNotification({
                            title: t("error_general")
                        });
                        (0,helpers/* resetForm */.Fx)(formRef.current);
                    case 98:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    11,
                    20
                ],
                [
                    53,
                    94
                ]
            ]);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cardHasError,
        confirmCardSetup,
        confirmCardPayment,
        createPaymentMethod,
        selectedCard,
        user,
        stripeError,
        stripeCard,
        promoCode,
        promoCodeError, 
    ]);
    var promoCodeJSX = (0,react.useMemo)(function() {
        var onClick = function onClick() {
            if (isPromoOpen) {
                resetPromoCode();
            }
            openPromo(!isPromoOpen);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: [
                    (index_module_default()).promoCode,
                    isPromoOpen ? (index_module_default()).openPromo : ""
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: onClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (index_module_default()).promoText,
                        onClick: onClick,
                        children: t("advanced_form.use_promo_code")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: promoCodeRef,
                        placeholder: t("advanced_form.promo_code_placeholder"),
                        type: "text",
                        name: "promoCode",
                        id: "promoCode",
                        className: promoCodeError ? "error" : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: promoCodeError
                    })
                ]
            })
        });
    }, [
        promoCodeError,
        isPromoOpen,
        promoCode,
        promoCodeError
    ]);
    var basicForm = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("main", {
            className: (index_module_default()).choosePlan,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: t("title")
                }),
                !(user === null || user === void 0 ? void 0 : user.had_subscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t((0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("payment_info", userRelatedCountryCode))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    ref: formRef,
                    onSubmit: onSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: [
                                "radios",
                                (index_module_default()).radios
                            ].join(" "),
                            children: [
                                localPlans === null || localPlans === void 0 ? void 0 : localPlans.map(function(plan, i) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "radio",
                                                name: "plan",
                                                value: "".concat(plan.id, ":").concat(plan === null || plan === void 0 ? void 0 : (ref = plan.price) === null || ref === void 0 ? void 0 : ref.currency),
                                                id: "".concat(plan.id),
                                                defaultChecked: (type === enums/* QueryType.Monthly */.xL.Monthly || !type) && i === 0 || type === enums/* QueryType.Yearly */.xL.Yearly && i === 1,
                                                onChange: function() {
                                                    setBuyType(enums/* BuyType.Card */.D.Card);
                                                    if ((plan === null || plan === void 0 ? void 0 : plan.recurrence.length) === 1 && (plan === null || plan === void 0 ? void 0 : plan.recurrence.unit) === "MONTH") {
                                                        setQueryType(enums/* QueryType.Monthly */.xL.Monthly);
                                                    } else {
                                                        setQueryType(enums/* QueryType.Yearly */.xL.Yearly);
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                className: [
                                                    "radio",
                                                    (index_module_default()).radio
                                                ].join(" "),
                                                htmlFor: "".concat(plan.id),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: plan.title
                                                    }),
                                                    t("choose-plan:price_with_vat", {
                                                        price: plan.price.formatted
                                                    })
                                                ]
                                            })
                                        ]
                                    }, plan.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    onChange: function() {
                                        setBuyType(enums/* BuyType.Voucher */.D.Voucher);
                                        setQueryType(enums/* QueryType.Voucher */.xL.Voucher);
                                        setSelectedCard("");
                                        setLocalPlans(plans);
                                    },
                                    type: "radio",
                                    defaultChecked: type === enums/* QueryType.Voucher */.xL.Voucher,
                                    name: "plan",
                                    value: "planVoucher",
                                    id: "planVoucher"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: [
                                        "radio",
                                        (index_module_default()).radio
                                    ].join(" "),
                                    htmlFor: "planVoucher",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/png/icGift.png",
                                            alt: "gift"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "gift",
                                            children: t("got_voucher")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default()).subInfo,
                            children: !(user === null || user === void 0 ? void 0 : user.needsToPay) && t("payment_sub_info", {
                                yearPriceDiff: priceYearlyDiscount
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: getVoucherInputCls,
                            children: [
                                t("voucher_label"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    placeholder: t("voucher_placeholder"),
                                    type: "text",
                                    name: "voucher",
                                    id: "voucher"
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    ref: serverError
                                })
                            ]
                        }),
                        buyType === enums/* BuyType.Card */.D.Card && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards/* default */.Z, {
                                    setSelected: setSelectedCard,
                                    selected: selectedCard
                                }),
                                promoCodeJSX
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "submit",
                            className: "btn btn-primary",
                            children: getBtnText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeDisclaimer/* default */.Z, {})
                    ]
                })
            ]
        });
    }();
    var advancedForm = !(user === null || user === void 0 ? void 0 : user.showAdvancedChoosePlanForm) ? null : function() {
        if (buyType === enums/* BuyType.Voucher */.D.Voucher) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: [
                    (index_module_default()).choosePlan,
                    (index_module_default()).advancedForm
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            (index_module_default()).primary,
                            (index_module_default()).primaryVoucher
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: t("choose-plan:advanced_form.voucher_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    setBuyType(enums/* BuyType.Card */.D.Card);
                                },
                                children: t("choose-plan:advanced_form.switch_to_card")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                ref: formRef,
                                onSubmit: onSubmit,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "hidden",
                                        name: "plan",
                                        value: "planVoucher",
                                        id: "planVoucher"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: getVoucherInputCls,
                                        children: [
                                            t("voucher_label"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                placeholder: t("voucher_placeholder"),
                                                type: "text",
                                                name: "voucher",
                                                id: "voucher"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                ref: serverError
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-primary",
                                        children: t("common:form.activate")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: [
                            (index_module_default()).secondary,
                            (index_module_default()).secondaryVoucher
                        ].join(" "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: t("choose-plan:advanced_form.voucher_description_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("choose-plan:advanced_form.voucher_description_subtitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                href: helpers/* Permalink.voucher */.xm.voucher(locale),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: t("choose-plan:advanced_form.voucher_description_action")
                                })
                            })
                        ]
                    })
                ]
            });
        }
        var discount = "".concat(Math.floor((+localPlans[1].price.value / 12 / +localPlans[0].price.value - 1) * 100), "%");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            className: [
                (index_module_default()).choosePlan,
                (index_module_default()).advancedForm
            ].join(" "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).primary,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: t("choose-plan:advanced_form.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#",
                            onClick: function(e) {
                                e.preventDefault();
                                setBuyType(enums/* BuyType.Voucher */.D.Voucher);
                            },
                            children: t("choose-plan:advanced_form.switch_to_voucher")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            ref: formRef,
                            onSubmit: onSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: [
                                        "radios",
                                        (index_module_default()).radios
                                    ].join(" "),
                                    children: localPlans === null || localPlans === void 0 ? void 0 : localPlans.map(function(plan, i) {
                                        var ref;
                                        var isMonthly = plan.recurrence.unit === "MONTH";
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    name: "plan",
                                                    value: "".concat(plan.id, ":").concat(plan === null || plan === void 0 ? void 0 : (ref = plan.price) === null || ref === void 0 ? void 0 : ref.currency),
                                                    id: "".concat(plan.id),
                                                    defaultChecked: (queryType === enums/* QueryType.Monthly */.xL.Monthly || !queryType) && i === 0 || queryType === enums/* QueryType.Yearly */.xL.Yearly && i === 1,
                                                    onChange: function() {
                                                        setBuyType(enums/* BuyType.Card */.D.Card);
                                                        if ((plan === null || plan === void 0 ? void 0 : plan.recurrence.length) === 1 && isMonthly) {
                                                            setQueryType(enums/* QueryType.Monthly */.xL.Monthly);
                                                        } else {
                                                            setQueryType(enums/* QueryType.Yearly */.xL.Yearly);
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: [
                                                        "radio",
                                                        (index_module_default()).radio
                                                    ].join(" "),
                                                    htmlFor: "".concat(plan.id),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                                            i18nKey: (0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("choose-plan:advanced_form.".concat(isMonthly ? "monthly" : "yearly"), userRelatedCountryCode),
                                                            components: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {})
                                                            ],
                                                            values: {
                                                                price_formatted: plan.price.formatted
                                                            }
                                                        }),
                                                        i === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: discount
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, plan.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: getVoucherInputCls,
                                    children: [
                                        t("voucher_label"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            placeholder: t("voucher_placeholder"),
                                            type: "text",
                                            name: "voucher",
                                            id: "voucher"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            ref: serverError
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards/* default */.Z, {
                                    setSelected: setSelectedCard,
                                    selected: selectedCard
                                }),
                                promoCodeJSX,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    disabled: submitDisabled,
                                    className: "btn btn-primary",
                                    children: t((0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("choose-plan:advanced_form.button_activate", userRelatedCountryCode))
                                })
                            ]
                        })
                    ]
                }),
                isTrialAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).secondary,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                i18nKey: (0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("choose-plan:advanced_form.timeline_title", userRelatedCountryCode),
                                components: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (index_module_default()).timeline,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                        i18nKey: (0,helpers/* getNoTrialTranslationKeyIfNeeded */.jU)("choose-plan:advanced_form.timeline_step_1", userRelatedCountryCode),
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                        i18nKey: "choose-plan:advanced_form.timeline_step_4",
                                        values: {
                                            date_formatted: (0,helpers/* formatDate */.p6)(new Date(Date.now() + 5 * 24 * 60 * 60 * 1000), locale)
                                        },
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                        i18nKey: "choose-plan:advanced_form.timeline_step_2",
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ],
                                        values: {
                                            date_formatted: (0,helpers/* formatDate */.p6)(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), locale)
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: t("choose-plan:advanced_form.timeline_step_3")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }();
    if (redirecting) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* BrowseSkeleton */.C_, {
            countryCode: countryCode
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        countryCode: countryCode,
        allowPopups: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,jsx/* basicSEO */.F)(t("seo:choose_plan_title"), t("seo:choose_plan_description"))
            }),
            user && !user.showAdvancedChoosePlanForm && basicForm,
            user && user.showAdvancedChoosePlanForm && advancedForm
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var choose_plan = ((0,authContext/* withNoSubscription */.JH)((0,stripeContext/* ProvideStripe */.U)(ChoosePlan)));


/***/ }),

/***/ 12701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardLabel":"Cards_cardLabel__l0VA0","cardIcon":"Cards_cardIcon__nBYYK"};

/***/ }),

/***/ 21861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"choosePlan":"choose-plan_choosePlan__RdBx4","voucherInput":"choose-plan_voucherInput__hyJMJ","radios":"choose-plan_radios__4pDmc","radio":"choose-plan_radio__anThP","hidden":"choose-plan_hidden__JC9gB","subInfo":"choose-plan_subInfo__224nN","notVisible":"choose-plan_notVisible__rZE0n","visible":"choose-plan_visible__lVIrK","stripeDisclaimer":"choose-plan_stripeDisclaimer__hbWRX","advancedForm":"choose-plan_advancedForm__Mtpog","promoText":"choose-plan_promoText__L2i_0","primary":"choose-plan_primary__wAhQI","secondary":"choose-plan_secondary__78djI","primaryVoucher":"choose-plan_primaryVoucher__IAhXs","secondaryVoucher":"choose-plan_secondaryVoucher__rDIZQ","timeline":"choose-plan_timeline__Rx501","promoCode":"choose-plan_promoCode__vWt4g","openPromo":"choose-plan_openPromo__ZcSGO","enlarge":"choose-plan_enlarge__oMFgw","enlargeAndShift":"choose-plan_enlargeAndShift__JLTw3","grow":"choose-plan_grow___RQKm","rotate":"choose-plan_rotate__caz_8","slide-down":"choose-plan_slide-down__K96oe","slide-up":"choose-plan_slide-up__45JU8","progressShow":"choose-plan_progressShow__KXFze","pulsate":"choose-plan_pulsate__S_ShO","fromHalfOpacityToFull":"choose-plan_fromHalfOpacityToFull__e6Y4m"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4743,5429,9774,2888,179], function() { return __webpack_exec__(82714); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);